// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__MvWpr","description":"PatientConsentPreview_description__2Cq6h"};